import type { Store } from "@reduxjs/toolkit";
import { IndexRedirect, Route, type RouteComponent } from "react-router";

import { PLUGIN_MULTI_FACTOR_AUTH } from "metabase/plugins";
import type { State } from "metabase/redux/store";

import AccountApp from "./app/containers/AccountApp";
import LoginHistoryApp from "./login-history/containers/LoginHistoryApp";
import { getNotificationRoutes } from "./notifications/routes";
import UserProfileApp from "./profile/containers/UserProfileApp";

export const getAccountRoutes = (
  _store: Store<State>,
  IsAuthenticated: RouteComponent,
) => {
  return (
    <Route path="/account" component={IsAuthenticated}>
      <Route component={AccountApp}>
        <IndexRedirect to="profile" />
        <Route path="profile" component={UserProfileApp} />
        {/* IAS overlay: /account/password route intentionally not mounted —
            IAS users authenticate through amelia SSO and can't change their
            Metabase password. Deep-linking to it falls through to NotFound. */}
        <Route
          path="security"
          component={PLUGIN_MULTI_FACTOR_AUTH.AccountSecurityPanel}
        />
        <Route path="login-history" component={LoginHistoryApp} />
        {getNotificationRoutes()}
      </Route>
    </Route>
  );
};
